import SpecificGameContainer from './specificGame'

export default SpecificGameContainer